import React from 'react';
import PropTypes from 'prop-types';
import { PreviewContainer, PreviewButton } from './PreviewNewsletter.styles';

const PreviewNewsletter = ({ newsletter, showPreview, setShowPreview }) => {
  if (!newsletter) return null;

  return (
    <PreviewContainer>
      <PreviewButton type="button" onClick={() => setShowPreview((p) => !p)}>
        {showPreview ? 'Hide Newsletter Preview' : 'Display Newsletter'}
      </PreviewButton>
    </PreviewContainer>
  );
};

PreviewNewsletter.propTypes = {
  newsletter: PropTypes.shape({
    newsletterTitle: PropTypes.string,
    month: PropTypes.string,
    title1: PropTypes.string,
    content1: PropTypes.string,
    title2: PropTypes.string,
    content2: PropTypes.string,
    title3: PropTypes.string,
    content3: PropTypes.string,
  }),
  showPreview: PropTypes.bool,
  setShowPreview: PropTypes.func,
};

export default PreviewNewsletter;
